import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { Localiser } from '../../services/localiser';
import {UserService} from '../../services/user.service';
import {Navigation} from '../../services/navigation.service';
import {IndicatorsService} from '../../services/indicators.service';
import {ProyectoService} from "../../services/proyecto.service";

@Component({
  selector: 'app-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.css']
})
export class IndicatorsComponent implements AfterViewInit {


  constructor(public localiser: Localiser, public user: UserService, private navigation: Navigation,
              private indicatorsService: IndicatorsService, public proyectoService: ProyectoService) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("indicators");
      this.toLocations();
    } else {
      proyectoService.setLastPage("indicators")
    }
  }

  ngAfterViewInit(): void {
  }

  selectIndicator(n: number) {
    this.indicatorsService.setIndicator(n);
    this.navigation.toIndicatorsSelection();
  }

  toLocations() {
    this.navigation.toLocations();
  }

  toIndicatorPresences() {
    this.navigation.toIndicatorsPresences();
  }

  toIndicatorSensors() {
    this.navigation.toIndicatorsSensors();
  }

}
